import axios from "../../interceptors/axiosInterceptor";
import {
  CREATE_ORDER_URL,
  GET_ORDERS_DETAILS_URL,
  GET_ORDERS_URL,
  UPDATE_ORDER_URL,
  CHANGE_ORDER_STATUS_URL,
  CHECK_PRODUCT_AVAILABILITY,
  GET_ACTIVE_PROMOS_FOR_ORDER,
  MINIMUM_ORDER_VALUE,
  ORDER_PRICE_BREAKDOWN
} from "../../config/Url";
import {
  ICreateOrderPayload,
  IGetQueryParams,
  IFetchOrderResponse,
  IFetchOrderActionResponse,
  IOrderDetailResponseNormalized,
  IUpdateOrderPayload,
  IUpdateOrderStatusPayload,
  ICheckProductRequestPayload,
  ICheckProductResponsePayload,
  IActivePromosForOrderPayload,
  IOrderPriceBreakdown
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import {
  normalizeFetchOrderResponse,
  normalizeOrderDetailsResponse,
} from "../../normalizer/OrderNormalizer";

export const createOrderApiCall = (payload: ICreateOrderPayload) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(CREATE_ORDER_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchOrdersApiCall = (queryParam: IGetQueryParams = {}) =>
  new Promise<IFetchOrderActionResponse>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_ORDERS_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data: Array<IFetchOrderResponse> = response.data;
          const pageNumber = queryParam.page ? Number(queryParam.page) + 1 : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 25
              ? true
              : false;
          resolve(
            normalizeFetchOrderResponse(
              data,
              Number(pageNumber),
              isPaginatedRes
            )
          );
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchOrdersDetailsApiCall = (id: string) =>
  new Promise<IOrderDetailResponseNormalized>((resolve, reject) => {
    let url = GET_ORDERS_DETAILS_URL.replace("{order_id}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          const normalizedRes: IOrderDetailResponseNormalized =
            normalizeOrderDetailsResponse(data);
          resolve(normalizedRes);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateOrderApiCall = (id: string, payload: IUpdateOrderPayload) =>
  new Promise<void>((resolve, reject) => {
    let url = UPDATE_ORDER_URL.replace("{order_id}", id);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateOrderStatusApiCall = (
  id: string,
  payload: IUpdateOrderStatusPayload
) =>
  new Promise<void>((resolve, reject) => {
    let url = CHANGE_ORDER_STATUS_URL.replace("{order_id}", id);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const checkProductAvailabilityAPI = (
  payload: ICheckProductRequestPayload
) =>
  new Promise<ICheckProductResponsePayload[]>((resolve, reject) => {
    axios
      .post(CHECK_PRODUCT_AVAILABILITY, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          const data: ICheckProductResponsePayload[] = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchPromosForOrderApiCall = () =>
  new Promise<IActivePromosForOrderPayload>((resolve, reject) => {
    axios
      .get(GET_ACTIVE_PROMOS_FOR_ORDER, getAuthOptions())
      .then((response) => {
        if (response) {
          const data: IActivePromosForOrderPayload = response.data;
          // (data.BASKET.payload as IBasketPromoMeta)
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchMinimumOrderValueApiCall = (cityId: string) =>
  new Promise<IOrderDetailResponseNormalized>((resolve, reject) => {
    let url = MINIMUM_ORDER_VALUE.replace("{cityId}", cityId);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchOrderPriceBreakdownApiCall = (
  queryParam: IGetQueryParams = {}
) =>
  new Promise<IOrderPriceBreakdown>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(ORDER_PRICE_BREAKDOWN, requestConfig)
      .then((response) => {
        if (response) {
          const data: IOrderPriceBreakdown =
            response.data && response.data.length > 0 ? response.data[0] : null;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
